// Mock data para o site NefilinSEC
export const mockData = {
  // Hero Section
  hero: {
    title: "Segurança Cibernética Avançada",
    subtitle: "Proteja seu Negócio",
    description: "Sua empresa está segura contra ameaças digitais? Nossa equipe de especialistas em cibersegurança oferece serviços de pentest robustos para identificar vulnerabilidades e fortalecer suas defesas.",
    ctaText: "Solicite uma Avaliação de Segurança",
    backgroundImage: "https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxjeWJlcnNlY3VyaXR5fGVufDB8fHxibGFja3wxNzU3Mzc3NTYxfDA&ixlib=rb-4.1.0&q=85"
  },

  // Sobre a empresa
  about: {
    title: "Sobre a NefilinSEC",
    description: "Somos uma empresa especializada em segurança cibernética, com foco em pentest e análise de vulnerabilidades. Nossa equipe é composta por profissionais experientes e certificados, comprometidos em oferecer soluções personalizadas para proteger seus sistemas e dados.",
    mission: "Oferecer serviços de pentest de alta qualidade e soluções personalizadas para proteger seus sistemas e dados contra ameaças cibernéticas.",
    vision: "Ser referência em segurança cibernética, reconhecidos pela expertise em pentest e pelo compromisso com a segurança de nossos clientes.",
    values: "Ética, profissionalismo, inovação, comprometimento, excelência."
  },

  // Serviços
  services: [
    {
      id: 1,
      title: "Pentest de Infraestrutura",
      description: "Avaliação completa da segurança de redes, servidores e infraestrutura IT para identificar vulnerabilidades críticas.",
      icon: "Shield",
      features: ["Testes de rede", "Análise de servidores", "Verificação de firewall", "Relatórios técnicos"]
    },
    {
      id: 2,
      title: "Pentest de Aplicações Web & Mobile",
      description: "Testes abrangentes em aplicações web e móveis para garantir a segurança dos seus sistemas digitais.",
      icon: "Globe",
      features: ["Análise de código", "Testes de OWASP Top 10", "Validação de APIs", "Segurança mobile"]
    },
    {
      id: 3,
      title: "Teste em Redes Wi-Fi",
      description: "Avaliação da segurança de redes wireless para prevenir acessos não autorizados e vazamentos de dados.",
      icon: "Wifi",
      features: ["Análise WPA/WPA2", "Detecção de rogue APs", "Testes de criptografia", "Auditoria de redes"]
    },
    {
      id: 4,
      title: "Engenharia Social",
      description: "Simulação de ataques de phishing e conscientização para fortalecer o fator humano na segurança.",
      icon: "Users",
      features: ["Campanhas de phishing", "Treinamentos", "Simulações reais", "Conscientização"]
    }
  ],

  // Metodologia
  methodology: [
    {
      step: 1,
      title: "Planejamento",
      description: "Definição do escopo do teste, objetivos, metodologia e recursos."
    },
    {
      step: 2,
      title: "Reconhecimento",
      description: "Coleta de informações sobre o ambiente alvo, como infraestrutura, sistemas e aplicações."
    },
    {
      step: 3,
      title: "Escaneamento",
      description: "Verificação de vulnerabilidades e falhas de segurança utilizando ferramentas automatizadas e técnicas manuais."
    },
    {
      step: 4,
      title: "Exploração",
      description: "Exploração de vulnerabilidades identificadas para obter acesso a sistemas e dados confidenciais."
    },
    {
      step: 5,
      title: "Ataque",
      description: "Simulação de ataques reais para avaliar a efetividade das medidas de segurança implementadas."
    },
    {
      step: 6,
      title: "Relatório",
      description: "Documentação detalhada dos resultados do pentest, incluindo vulnerabilidades encontradas, recomendações de correção e evidências de testes."
    }
  ],

  // Equipe
  team: {
    title: "Nosso Time de Especialistas",
    description: "Nossa equipe é composta por especialistas em segurança cibernética com vasta experiência em pentest e análise de vulnerabilidades.",
    leader: {
      name: "Equipe",
      position: "Especialistas em Cybersecurity, Red Team e Pentest",
      description: "Equipe técnica com mais de 10 anos de experiência em segurança cibernética, especializada em testes de intrusão e red team operations.",
      image: "https://images.unsplash.com/photo-1632910121591-29e2484c0259?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHx0ZWNoJTIwdGVhbSUyMHByb2Zlc3Npb25hbHN8ZW58MHx8fHwxNzU3Mzc3NTkwfDA&ixlib=rb-4.1.0&q=85"
    },
    stats: [
      { label: "Anos de Experiência", value: "10+" },
      { label: "Certificações", value: "ISO/IEC 27001" },
      { label: "Projetos Realizados", value: "500+" },
      { label: "Clientes Atendidos", value: "200+" }
    ]
  },

  // Benefícios
  benefits: [
    {
      title: "Identificação de Vulnerabilidades",
      description: "Avaliamos a segurança de seus sistemas e aplicações, identificando possíveis vulnerabilidades que podem ser exploradas por atacantes.",
      icon: "Search"
    },
    {
      title: "Prevenção de Ataques",
      description: "Ao identificar as vulnerabilidades, podemos recomendar medidas de segurança para prevenir ataques e proteger seu negócio.",
      icon: "ShieldCheck"
    },
    {
      title: "Melhorar a Segurança",
      description: "O pentest ajuda a fortalecer sua postura de segurança, melhorando a proteção de seus dados, sistemas e infraestrutura.",
      icon: "Lock"
    },
    {
      title: "Conformidade com Regulamentos",
      description: "O pentest pode ajudar sua empresa a atender aos requisitos de conformidade com leis e regulamentos de segurança de dados.",
      icon: "FileCheck"
    }
  ],

  // Depoimentos
  testimonials: [
    {
      name: "João Silva",
      position: "Gerente de TI",
      company: "TechCorp",
      text: "Trabalhamos com a NefilinSEC há alguns anos e estamos muito satisfeitos com a qualidade dos seus serviços de pentest. Eles sempre nos fornecem relatórios detalhados e recomendações práticas para melhorar a segurança de nossos sistemas.",
      rating: 5
    },
    {
      name: "Maria Oliveira",
      position: "Diretora Financeira",
      company: "FinanceSecure",
      text: "A equipe da NefilinSec foi extremamente profissional e atenciosa durante o processo de pentest. Eles nos ajudaram a identificar vulnerabilidades importantes e a fortalecer nossa postura de segurança.",
      rating: 5
    },
    {
      name: "Pedro Santos",
      position: "CEO",
      company: "DataSafe Solutions",
      text: "Confio na expertise da NefilinSec para garantir a segurança de nossos dados e sistemas. Eles são especialistas em segurança cibernética e sempre nos fornecem soluções personalizadas para atender às nossas necessidades.",
      rating: 5
    }
  ],

  // Contato
  contact: {
    phone: "(21) 98117-6984",
    email: "contato@nefelinsec.com",
    website: "nefelinsec.com",
    cnpj: "55.664.421/0001-09",
    whatsapp: "5521981176984",
    linkedin: "https://linkedin.com/company/nefelinsec",
    address: "Rio de Janeiro, RJ"
  },

  // Estatísticas
  stats: [
    { label: "Projetos Realizados", value: "500+", icon: "Target" },
    { label: "Clientes Satisfeitos", value: "200+", icon: "Users" },
    { label: "Vulnerabilidades Encontradas", value: "2000+", icon: "AlertTriangle" },
    { label: "Anos de Experiência", value: "10+", icon: "Calendar" }
  ]
};